module.exports = __webpack_public_path__ + "static/media/Logo__CapitalOne.295dd0ec.svg";